import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const AddTeam = () => {
  const [teams, setTeams] = useState([]);
  const [message, setMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editTeam, setEditTeam] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  

  // Fetch teams from API
  const fetchTeams = async () => {
    try {
      const response = await fetch("http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/teams");
      const data = await response.json();
      setTeams(data);
    } catch (error) {
      console.error("Error fetching teams:", error);
    }
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  // Add or Update Team
  const onSubmit = async (data) => {
    try {
      let response;
      if (editTeam) {
        response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/teams/${editTeam._id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ teams: data.teamName }),
        });
      } else {
        response = await fetch("http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/teams", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ teams: data.teamName }),
        });
      }

      const result = await response.json();

      if (!response.ok) throw new Error(result.message || "Something went wrong");

      setMessage(result.message);
      reset();
      setIsModalOpen(false);
      setEditTeam(null);
      fetchTeams();
    } catch (error) {
      setMessage(error.message);
    }
  };

  // Open Edit Modal
  const handleEdit = (team) => {
    setEditTeam(team);
    setIsModalOpen(true);
    setValue("teamName", team.teams);
  };

  // Delete Team
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this team?")) return;
    try {
      const response = await fetch(`http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/teams/${id}`, { method: "DELETE" });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || "Something went wrong");

      setMessage(result.message);
      fetchTeams();
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Add Team Button */}
      <div className="w-full flex justify-end mb-4">
        <button
          onClick={() => {
            setEditTeam(null);
            setIsModalOpen(true);
            reset();
          }}
          className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
        >
          Add Team
        </button>
      </div>

      {/* Teams Table */}
      <div className="w-full max-w-3xl">
        <table className="min-w-full bg-white border rounded-lg shadow-md">
          <thead className="bg-gray-200">
            <tr>
              <th className="py-3 px-6 text-left">#</th>
              <th className="py-3 px-6 text-left">Team Name</th>
              <th className="py-3 px-6 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {teams.length > 0 ? (
              teams.map((team, index) => (
                <tr key={team._id} className="border-t">
                  <td className="py-3 px-6">{index + 1}</td>
                  <td className="py-3 px-6">{team.teams}</td>
                  <td className="py-3 px-6 flex justify-center space-x-2">
                    <button
                      onClick={() => handleEdit(team)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded-md hover:bg-yellow-600"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(team._id)}
                      className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4 text-gray-500">
                  No teams added yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-xl shadow-lg w-96">
            <h2 className="text-2xl font-bold mb-4">{editTeam ? "Edit Team" : "Add Team"}</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <input
                type="text"
                {...register("teamName", { required: "Team name is required" })}
                placeholder="Enter team name"
                className="w-full p-2 border border-gray-300 rounded-md"
              />
              {errors.teamName && <p className="text-red-500 text-sm mt-1">{errors.teamName.message}</p>}
              <div className="flex justify-end gap-4 mt-4">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                >
                  {editTeam ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {message && <p className="mt-4 text-green-600">{message}</p>}
    </div>
  );
};

export default AddTeam;
